module.exports = __webpack_public_path__ + "img/russische-kipburgers kopie.bde3d655.jpg";